import { useCallback, useEffect, useState } from 'react';

import { State } from '@/endpoints/itasca/state/getState';
import { getStates, statesToFilter } from '@/endpoints/itasca/state/getStates';
import { useAuth } from '@/providers/auth-provider';
import Logger from '@/utils/logger';

import { StateAccordian } from './stateAccordian';

export const StatesAccordians = () => {
  const { authStateLoading, isAnonymous } = useAuth();
  const [states, setStates] = useState<State[]>([]);

  const fetchStates = useCallback(async () => {
    try {
      if (authStateLoading || !isAnonymous) return;
      const { res } = await getStates({
        params: { include__geometry: false, limit: 100, offset: 0 },
      });

      if (res) {
        const filteredStates = res.data.results.filter(
          (state) => !statesToFilter.includes(state.state_abbrev)
        );

        setStates(filteredStates);
      }
    } catch (err) {
      Logger.error(err);
    }
  }, [authStateLoading, isAnonymous]);

  useEffect(() => {
    fetchStates();
  }, [fetchStates]);

  return (
    <div className="w-full">
      {states.map((state) => {
        return <StateAccordian key={state.state_fips} state={state} />;
      })}
    </div>
  );
};
